<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-09 17:32:06
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-23 08:34:19
 * @Description: 
-->
<template>
  <div>
    <m-header />
    <slot />
    <m-footer />
    <scroll-to-top />
    <consultation-modal v-model="isConsultationOpen" />
  </div>
</template>

<script setup lang="ts">
  const { isConsultationOpen } = useConsultation()
</script>
